export areaContent from './area-content/handlers';
export listingContent from './listing-content/handlers';
export propertyContent from './property-content/handlers';
export propertyReview from './property-review/handlers';



// WEBPACK FOOTER //
// ./src/frontend/modules/content/handlers.js